import React from 'react'
import styled from 'styled-components'

const Styling = styled.div`
width:100%;
margin-bottom: 4rem;

    @media only screen and (min-width: 1100px) {
        margin-bottom: 8rem;
    }



    &:last-of-type{
        margin-bottom: 0;
    }

    .alignment{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

        @media only screen and (min-width: 1100px) {
        flex-wrap: nowrap;
        }


        .image-wrapper{
        width:100%;
        padding-bottom: 56%;
        height:0;
        position: relative;
        //border:1rem solid var(--white);
        background:var(--white);

            @media only screen and (min-width: 1100px) {
            width:calc(50% - 2rem);
            padding-bottom: 26%;
            }


            .gatsby-image-wrapper{
            position:absolute !important;
            top:0 !important;
            left:0 !important;
            width:100% !important;
            height:100% !important;
            }    
        }

        .text{
        width:100%;
        ${({theme}) => theme.textStyling()}  
        margin-bottom: 4rem;
        
            @media only screen and (min-width: 1100px) {
            width:calc(50% - 2rem);
            margin-bottom: 0;
            }


        }

        &-iltr{
            .text{
            margin-left:0;
            order:1;

                @media only screen and (min-width: 1100px) {
                order:2;
                margin-left:4rem;
                }
            }

            .image-wrapper{
            order:2;
                
                @media only screen and (min-width: 1100px) {
                order:1;
                }
            }
        }

        &-tlIr{
            .text{
            order:1;

                @media only screen and (min-width: 1100px) {
                margin-right:4rem;
                }
            }

            .image-wrapper{
            order:2;
            }
        }

    }

`

export { Styling }